import * as React from 'react';
import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Box, Container, Grid, Typography, TextField,
 Button, MenuItem, Select, InputLabel, Snackbar, Alert, CircularProgress, 
 Dialog, DialogTitle, DialogContent, DialogActions, Autocomplete, Paper } from "@mui/material";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import StepProgress from './StepProgress';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export default function FormComponent() {


 // State variables for form fields
 const [formData, setFormData] = useState({
   First_Name: "",
   Last_Name: "",
   DOB: "",
   Mobile_Number: "",
   City: "",
   District: "",
   State: "",
   Pincode: "",
   ID_Proof_Type: "", 
   ID_Proof_Number: "",
   Pan_Card:"",
   Pan_Number:  "",
   User_Type: "",
   Member_ID: "",
   Email: "",
   Family_Details: "",
   Occupation: "",
   Address: "",
   Marital_Status: "",
   Star: "",
   Raasi: "",
   Kootram: "",
   Kuladeivam: "",
   Payment_Status: ""
 });
    
 
 const isPaymentPending = formData?.Payment_Status !== "Paid";
 const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
 const [isSubmitted, setIsSubmitted] = useState(false);
 const [snackbarOpen, setSnackbarOpen] = useState(false);
 const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [isPaymentLoading, setIsPaymentLoading] = useState(false);

  const originalPanCardFromDB = useRef(formData.Pan_Card === "Yes");
  const originalPanNumberFromDB = useRef(formData.Pan_Number || "");
  
  const [cachedPanNumber, setCachedPanNumber] = useState(formData.Pan_Number || "");
  

      const validateForm = () => {
       let newErrors = {};
    
       if (!formData.Occupation.trim()) {
         newErrors.Occupation = "Occupation is required"; 
       }
       if (!formData.Address?.trim()) {
        newErrors.Address = "Address is required ";
      }
       if (!formData.Email.trim()) {
         newErrors.Email = "Email is required";
       } else if (
         !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.Email)
       ) {
         newErrors.Email = "Enter a valid email address";
       }
       if (!String(formData.Family_Details || "").trim()) {
        newErrors.Family_Details = "Family Details is required";
      }
    
      
      
       if (!formData.Marital_Status.trim()) {
        newErrors.Marital_Status = "Please select Marital Status ";
      }

      if (!formData.ID_Proof_Type) {
        newErrors.ID_Proof_Type = true;
      }
  
      if (!formData.Pan_Card) {
        newErrors.Pan_Card = true;
      }

      // if (formData.ID_Proof_Type === "aadhaar") {
      //   if (!formData.ID_Proof_Number || !/^\d{12}$/.test(formData.ID_Proof_Number)) {
      //     newErrors.ID_Proof_Number = "Enter a valid Aadhaar Number (must be 12 digits)";
      //   }
      // }
    
      // if (formData.ID_Proof_Type === "license") {
      //   if (!formData.ID_Proof_Number || !/^[A-Z]{2}\d{13}$/.test(formData.ID_Proof_Number)) {
      //     newErrors.ID_Proof_Number = "Enter a valid License Number (e.g., AB1234567890123)";
      //   }
      // }

     
      
      //  if (formData.Pan_Card === "Yes") {
      //   if (!formData.Pan_Number || !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(formData.Pan_Number)) {
      //     newErrors.Pan_Number = "Enter a valid PAN Number (Eg: ABCDE1234F)";
      //   }
      // }

       setErrors(newErrors);

       if (Object.keys(newErrors).length > 0) {
        setSnackbarMessage("Please fill all the mandatory fields");
        console.log("Validation Errors:", newErrors);
        setSnackbarOpen(true);
        return false;
      } 

      if (setSnackbarOpen) {
        setTimeout(() => setSnackbarOpen(false), 100);
      }

      setIsLoading(true);
      return true;
 };


 const [formData2, setFormData2] = useState({
   firstName: "",
   lastName: "",
   mobile: "",
   dob: "",
   city: "",
   district: "",
   state: "",
   pincode: "",
   identityProofType: "",
   identityProofNumber: "",
   panCard: "",
   panCardNumber: "",
   email: "",
   occupation: "",
   address: "",
   familyDetails: "",
   maritalStatus: "",
   star: "",
   raasi: "",
   kootram: "",
   kuladeivam: ""
 });


 useEffect(() => {
   setFormData2({
     firstName: formData.First_Name,
     lastName: formData.Last_Name,
     mobile: formData.Mobile_Number,
     dob: formData.DOB,
     city: formData.City,
     district: formData.District,
     state: formData.State,
     pincode: formData.Pincode,
     identityProofType: formData.ID_Proof_Type,
     identityProofNumber: formData.ID_Proof_Number,
     panCard: formData.Pan_Card,
     panCardNumber: formData.Pan_Number,
     email: formData.Email,
     occupation: formData.Occupation,
     address: formData.Address,
     familyDetails: formData.Family_Details,
     maritalStatus: formData.Marital_Status,
     star: formData.Star,
     raasi: formData.Raasi,
     kootram: formData.Kootram,
     kuladeivam: formData.Kuladeivam
   });
 }, [formData]);


 const handleSubmit = async (e) => {
  
   e.preventDefault();
 
   setIsSubmitted(true);
   if (!validateForm()) return;
 

   const formattedDob = new Date(formData.DOB).toLocaleDateString('en-CA');

   setFormData2({
     firstName: formData.First_Name,
     lastName: formData.Last_Name,
     mobile: formData.Mobile_Number,
     dob: formattedDob,
     city: formData.City,
     district: formData.District,
     state: formData.State,
     pincode: formData.Pincode,
     identityProofType: formData.ID_Proof_Type,
     identityProofNumber: formData.ID_Proof_Number,
     panCard: formData.Pan_Card,
     panCardNumber: formData.Pan_Number,
     email: formData.Email,
     occupation: formData.Occupation,
     address: formData.Address,
     familyDetails: formData.Family_Details,
     maritalStatus: formData.Marital_Status,
     star: formData.Star,
     raasi: formData.Raasi,
     kootram: formData.Kootram,
     kuladeivam: formData.Kuladeivam,
 });

 

   const requestBody = {
     method: "patch",  
     ...formData2,  
 };


   try {
       // eslint-disable-next-line
       const response = await fetch(
          API_BASE_URL,
           {
               method: "POST",
               mode: "cors", 
              //  headers: {
              //      "Content-Type": "application/json",
              //  },
               body: JSON.stringify({ method: "patch", ...formData2 }),
           }
       );

       const result = await response.json();

       if (result.status === "error") {
         setSnackbarMessage(result.message); // Show error message
         setSnackbarOpen(true);
         setIsLoading(false);
         return; 
     }
       console.log(formData2);
       console.log("Form sent successfully", formData);
       // Show confirmation message (if needed)
    
       setSnackbarMessage("Form submitted successfully!");
       setOpenSnackbar(true);
       setIsLoading(false);


           // Clear the form after submission
           setFormData({
              First_Name: "",
              Last_Name: "",
              DOB: "",
              Mobile_Number: "",
              City: "",
              District: "",
              State: "",
              Pincode: "",
              ID_Proof_Type: "", 
              ID_Proof_Number: "",
              Pan_Card:"",
              Pan_Number:  "",
              User_Type: "",
              Member_ID: "",
              Email: "",
              Family_Details: "",
              Occupation: "",
              Address: "",
              Marital_Status: "",
              Star: "",
              Raasi: "",
              Kootram: "",
              Kuladeivam: "",
              Payment_Status: ""
            
              });


         // Redirect after success
         setTimeout(() => {
             navigate("/membership");
             window.scrollTo(0, 0);
         }, 2000);

          // Determine navigation based on payment status
        if (formData?.Payment_Status?.toLowerCase() === "paid") {
          setTimeout(() => {
              navigate("/membership"); 
          }, 2000);
      } else {
          setTimeout(() => {
              navigate("/paymentgateway"); 
          }, 2000);
      }
      
   } catch (error) {
       console.error("Error sending data:", error);
       setSnackbarMessage("Something went wrong!");
       setSnackbarOpen(true);
       alert("Failed to send data");
   }
};

const handleProceedPayment = async () => {
  // Submit the form without validating required fields

  const formattedDob = new Date(formData.DOB).toLocaleDateString('en-CA');

  const formDataToSubmit = {
    firstName: formData.First_Name,
    lastName: formData.Last_Name,
    mobile: formData.Mobile_Number,
    dob: formattedDob,
    city: formData.City,
    district: formData.District,
    state: formData.State,
    pincode: formData.Pincode,
    identityProofType: formData.ID_Proof_Type,
    identityProofNumber: formData.ID_Proof_Number,
    panCard: formData.Pan_Card,
    panCardNumber: formData.Pan_Number,
    email: formData.Email,
    occupation: formData.Occupation,
    address: formData.Address,
    familyDetails: formData.Family_Details,
    maritalStatus: formData.Marital_Status,
    star: formData.Star,
    raasi: formData.Raasi,
    kootram: formData.Kootram,
    kuladeivam: formData.Kuladeivam,
  };

  try {
          setIsPaymentLoading(true);
          const response = await fetch(API_BASE_URL, {
            method: "POST",
            mode: "cors",
            body: JSON.stringify({ method: "patch", ...formDataToSubmit }),
          });

          const result = await response.json();

          if (result.status === "error") {
            setSnackbarMessage(result.message);
            setSnackbarOpen(true);
            return;
          }

          // Show success
          setSnackbarMessage("Form submitted successfully!");
          setOpenSnackbar(true);

          // Navigate to payment gateway
          navigate("/paymentgateway", { state: { fromRegistration: true, fromProfile: true } });
          window.scrollTo(0, 0);

        } catch (error) {
          console.error("Error:", error);
          setSnackbarMessage("Something went wrong!");
          setSnackbarOpen(true);
        } finally {
          setIsPaymentLoading(false);
        }
      };

     const handleCloseSnackbar = () => {
       setOpenSnackbar(false);
     };


const [openSnackbar, setOpenSnackbar] = useState(false);
const navigate = useNavigate();


const districts = ["Ariyalur", "Chengalpattu", "Chennai", "Coimbatore", "Cuddalore", "Dharmapuri",
 "Dindigul" , "Erode", "Kallakurichi", "Kancheepuram", "Kanyakumari", "Karur","Karaikal", "Krishnagiri", 
 "Madurai", "Mayiladuthurai", "Nagapattinam", "Namakkal",
 "Nilgiris", "Perambalur", "Pudukkottai", "Ramanathapuram", "Ranipet", "Salem", "Sivaganga",
 "Tenkasi", "Thanjavur", "Theni", "Thoothukudi", "Thiruchirappalli", "Tirunelveli", "Tirupathur",
 "Tiruppur", "Tiruvallur", "Tiruvannamalai", "Tiruvarur", "Vellore", "Viluppuram", "Virudhunagar", "Other"
];
const states = ["Tamil Nadu" , "Other"];


const Stars = ["Ashwini", "Bharani","Krithikai","Rohini", "Mirgasheersham", "Thiruvaathirai" , "Punarpoosam", "Poosam",
 ,"Aayilyam","Makam","Pooram","Uthiram","Hastham","Chithirai","Swaathi","Visaakam"
 ,"Anusham","Kettai", "Moolam","Pooraadam","Uthiraadam","Thiruvonam","Avittam",
"Chathayam/Sadayam","Poorattathi", "Uthirattathi", "Revathi" ]


  // Handles radio button changes
const handleRadioChange = (e) => {


 setFormData({ ...formData, ID_Proof_Type: e.target.value });
 
};


  // Handles radio button changes
  const handlestatusChange = (e) => {
   setFormData({ ...formData, Marital_Status: e.target.value });
 };


 const handlePanChange = (e) => {
  const value = e.target.value;

  // Prevent switching to "No" if PAN number already exists
  if (value === "No" && formData.Pan_Number) {
    setSnackbarMessage("You have already provided a PAN Number. You cannot change it to 'No'.");
    setSnackbarOpen(true);
    return;
  }

  if (value === "No") {
    if (originalPanCardFromDB.current) {
      setCachedPanNumber(originalPanNumberFromDB.current);
    } else {
      setCachedPanNumber("");
    }
  }

  setFormData((prevData) => ({
    ...prevData,
    Pan_Card: value,
    Pan_Number:
      value === "Yes"
        ? originalPanCardFromDB.current
          ? originalPanNumberFromDB.current
          : ""
        : ""
  }));

  if (value === "No" && formData.ID_Card?.toLowerCase() !== "generated") {
    setOpenDialog(true);
  }
};





 useEffect(() => {
   // Get mobile number & user type from localStorage
   const mobile = localStorage.getItem("mobile");
   const userType = localStorage.getItem("user_type");


   if (!mobile || !userType) {
     console.error("Mobile number or user type not found in localStorage");
     return;
   }


   // Fetch API data
   axios
     .get(`${API_BASE_URL}?action=myprofile&mobile=${mobile}`)
     .then((response) => {
       if (response.data.status === "success") {
        setLoading(false)
        
         console.log(response.data.data)
   
         setFormData(response.data.data); 
       } else {
         console.error("API returned an error:", response.data.message);
       }
     })
     .catch((error) => {
       console.error("Error fetching data:", error);
     })
     .finally(()=>{
      setLoading(false);
     })
 }, []);


 const handleChange = (e) => {
   const { name, value } = e.target;
   setFormData((prevData) => ({
     ...prevData,
     [name]: value,
   }));
 };


 console.log("ID_ProofType:", formData.ID_Proof_Type);
 console.log("formData:", formData);

 const handleKeyDown = (e) => {
  if (e.key === "Enter") {
    e.preventDefault(); 
    console.log("Enter key pressed"); 
    handleSubmit(e);
  }
};



 return (
  
   <Box sx={{ backgroundColor: "#f8f9e9", py: 6, top: "150px", bottom: "150px", }}   >
     <Container>
     <Typography variant="h5" sx={{ fontWeight: "500", color: "#2A289C", textAlign: "center", fontSize: "32px"  }} gutterBottom>
                My Profile 
            </Typography>
       <StepProgress />
       <Typography variant="h6" sx={{ fontWeight: "300", color: "#7A7841", my: 2, fontSize: "16px", textAlign: "center" }}>
       To obtain your official Membership ID Card, please complete your profile and make a one-time payment of ₹2000.<br></br> 
       This helps us to verify your details and provide full access to membership benefits.
       </Typography>

       {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh" >
            <CircularProgress color="success" />
          </Box>
        ) : (

       <Grid item xs={12} md={6}>
         <Box
           component="form"
           sx={{
             backgroundColor: "#f8f9e9",
             padding: 4,
             borderRadius: "8px",
             border: "1px solid #CEC35E",
             boxShadow: 1,
             borderColors: "#CEC35E",
             boxShadow: 3,
             width: "90%",
              maxWidth: "900px",
              margin: "0 auto",
             
           }}
         >
           <div className="grid grid-cols-1 md:grid-cols-2 gap-4" onKeyDown={handleKeyDown} tabIndex="0">
             <TextField
               fullWidth
               disabled
               size="small"
               label="First Name"
               placeholder="First Name"
               name="First_Name"
               value={formData.First_Name}
               onChange={handleChange}
               inputProps={{ maxLength: 25, pattern: "[A-Za-z]*"}}
               onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
               sx={{ mb: 2 }}
               
               required
             />
             <TextField
               fullWidth
               required
               disabled
               size="small"
               label="Last Name"
               placeholder="Last Name"
               name="Last_Name"
               value={formData.Last_Name}
               onChange={handleChange}
               inputProps={{ maxLength: 25, pattern: "[A-Za-z]*" }}
               onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
               sx={{ mb: 2  }}
             />
          
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Date of Birth"
                  format="DD-MM-YYYY" 
                  disabled
                  value={formData.DOB ? dayjs(formData.DOB, "YYYY-MM-DD") : null}
                  onChange={(date) =>
                    setFormData({ ...formData, DOB: date ? date.format("YYYY-MM-DD") : "" })
                  }
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      required: true,
                    },
                  }}
                  disableFuture 
                />
              </LocalizationProvider>
               <TextField
               fullWidth
               required
               disabled
               size="small"
               label="Mobile Number"
               placeholder="Your Mobile Number"
               type="tel"
               name="Mobile_Number"
               value={formData.Mobile_Number}
               onChange={handleChange}
               inputProps={{ maxLength: 10, pattern: "[0-9]*" }}
               onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10)}
               sx={{ mb: 2 }}
             />
             <TextField
               fullWidth
               required
               disabled
               size="small"
               label="City"
               placeholder="City"
               name="City"
               value={formData.City}
               onChange={handleChange}
               sx={{ my: 2}}
               inputProps={{ maxLength: 30, pattern: "[A-Za-z]*" }}
               onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
             />
          


             <FormControl fullWidth required disabled>
             <InputLabel sx={{ backgroundColor: "#f8f9e9", px: 1, transform: "translate(14px, -6px) scale(0.75)",}} >District</InputLabel>
             <Select
             name="district"
             size="small"
             value={formData.District}
             onChange={handleChange}
             error={!!errors.District} 
               helperText={errors.District || ""}
               required
             sx={{ textAlign: "left" , my: 2, }} >
             {districts.map((district, index) => (
              <MenuItem key={index} value={district}>
               {district}
                </MenuItem>
                ))}
              </Select>
             </FormControl>


             <FormControl fullWidth  required disabled>
              <InputLabel>State</InputLabel>
              <Select name="state" value={formData.State}
              size="small"
              onChange={handleChange}
              error={!!errors.state} 
               helperText={errors.state|| ""}
               required
               sx={{ textAlign: "left", my: 2 }} >
               {states.map((state, index) => (
                <MenuItem key={index} value={state}>
                 {state}
                 </MenuItem>
                      ))}
                 </Select>
                  </FormControl>
             
                
             <TextField
               fullWidth
               required
               disabled
               label="Pincode"
               placeholder="Pincode"
               type="number"
               size="small"
               name="Pincode"
               value={formData.Pincode}
               onChange={handleChange}
               sx={{ my: 2 }}
               inputProps={{ maxLength: 10, pattern: "[0-6]*" }}
               onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '').slice(0, 6)}
             />
           
             <TextField
               fullWidth
               disabled
               label="Member ID"
               placeholder="Member ID"
               type="text"
               size="small"
               name="Member_ID"
               value={formData.Member_ID}
               onChange={handleChange}
               sx={{ mb: 2 }}
               inputProps={{ maxLength: 10, pattern: "[A-Za-z0-9]*" }}
               onInput={(e) => {
                 e.target.value = e.target.value
                   .replace(/[^A-Za-z0-9]/g, '')
                   .slice(0, 10);
               }}
             />
            
             
             <TextField
               fullWidth
               size="small"
               label="Occupation"
               placeholder="Occupation"
               type="text"
               name="Occupation"
               value={formData.Occupation}
               onChange={handleChange}
               sx={{ mb: 2 }}
               error={!!errors.Occupation} 
               helperText={errors.Occupation|| ""}
               required
               inputProps={{ maxLength: 30, pattern: "[A-Za-z]*" }}
               onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
               onKeyDown={handleKeyDown} 
              
             />
             <TextField
              fullWidth
              size="small"
              label="Address"
              placeholder="Address"
              type="text"
              name="Address"
              value={formData.Address}
             onChange={handleChange}
              sx={{ mb: 2 }}
              error={!!errors.Address} 
              helperText={errors.Address || ""}
              required
              inputProps={{ maxLength: 75, pattern: "[A-Za-z0-9,./\\-\\s]*" }}
              onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z0-9,./\-\s]/g, '')}
              onKeyDown={handleKeyDown} 
             />
             <TextField
               fullWidth
               size="small"
               label="Email ID"
               placeholder="Enter you Email ID"
               type="email"
               name="Email"
               value={formData.Email}
               onChange={handleChange}
               sx={{ mb: 2 }}
               error={!!errors.Email} 
               helperText={errors.Email|| ""}
               required
               inputProps={{ maxLength: 50 }}
               onKeyDown={handleKeyDown} 
             />
       
             <TextField
               fullWidth
               size="small"
               label="Family Details"
               placeholder="Number of Family Members"
               name="Family_Details"
               value={formData.Family_Details}
               onChange={handleChange}
               sx={{ mb: 2 }}
               error={!!errors.Family_Details} 
               helperText={errors.Family_Details|| ""}
               required
               inputProps={{ maxLength: 40, pattern: "[A-Za-z0-9, ]*" }}
               onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z0-9, ]/g, '')}
               onKeyDown={handleKeyDown} 
             />
         
            
                      <Autocomplete
                options={Stars}
                value={formData.Star}
                onChange={(event, newValue) => {
                  if (newValue) {
                    setFormData({ ...formData, Star: newValue });
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Star"
                    variant="outlined"
                    size="small"
                 
                    error={!!errors.Star}
                    helperText={errors.Star || ""}
                    sx={{
                      backgroundColor: "#f8f9e9",
                      mb: 2,
                      "& .MuiInputBase-input": {
                        caretColor: "transparent",
                        cursor: "pointer",
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                      sx: {
                        backgroundColor: "#f8f9e9",
                        px: 1,
                        transform: "translate(14px, -6px) scale(0.75)",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      readOnly: false,
                    }}
                  />
                )}
                disableClearable
                fullWidth
                autoHighlight
                PaperComponent={(props) => (
                  <Paper
                    {...props}
                    sx={{
                      backgroundColor: "#f8f9e9", 
                    }}
                  />
                )}
              />



                <Autocomplete
                  options={[
                    "Mesham", "Risabham", "Mithunam", "Kadagam", "Simmam", "Kanni",
                    "Thulam", "Viruchigam", "Dhanushu", "Magaram", "Kumbham", "Meenam"
                  ]}
                  value={formData.Raasi}
                  onChange={(event, newValue) => {
                    if (newValue) {
                      setFormData({ ...formData, Raasi: newValue });
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Raasi"
                      variant="outlined"
                      size="small"
                    
                      error={!!errors.Raasi}
                      helperText={errors.Raasi || ""}
                      sx={{
                        backgroundColor: "#f8f9e9",
                        mb: 2,
                        "& .MuiInputBase-input": {
                          caretColor: "transparent",
                          cursor: "pointer",
                        },
                      }}
                      InputLabelProps={{
                        shrink: true,
                        sx: {
                          backgroundColor: "#f8f9e9",
                          px: 1,
                          transform: "translate(14px, -6px) scale(0.75)",
                        },
                      }}
                      InputProps={{
                        ...params.InputProps,
                        readOnly: false,
                      }}
                    />
                  )}
                  disableClearable
                  fullWidth
                  autoHighlight
                  
                  PaperComponent={(props) => (
                    <Paper
                      {...props}
                      sx={{
                        backgroundColor: "#f8f9e9", 
                      }}
                    />
                  )}
                />

             <TextField
               fullWidth size="small"
               label="Gothram"
               placeholder="Gothram"
               name="Kootram"
               value={formData.Kootram}
               onChange={handleChange}
               sx={{ mb: 2 }}
               inputProps={{ maxLength: 50, pattern: "[A-Za-z]*" }}
               onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
               onKeyDown={handleKeyDown} 
             />
          
             <TextField
               fullWidth size="small"
               label="Kuladeivam"
               placeholder="Kuladeivam"
               name="Kuladeivam"
               value={formData.Kuladeivam}
               onChange={handleChange}
               sx={{ my: 2 }}
               inputProps={{ maxLength: 100, pattern: "[A-Za-z]*" }}
               onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
               onKeyDown={handleKeyDown} 
             />


                {/* Marital Status */}
                <Box sx={{ backgroundColor: "#f8f9e9", padding: 2}}>

               <Grid container spacing={2} alignItems="center">
              <Grid item xs={2} >
                  <FormLabel sx={{ whiteSpace: "nowrap" }} required > Marital Status</FormLabel>
               </Grid>
               <Grid item xs={12} sm={10}  >
                 <FormControl component="fieldset" style={{ marginLeft: "22px" }} >
                   <RadioGroup row name="maritalStatus" value={formData.Marital_Status}
                   onChange={handlestatusChange}
                   
                   >
                     <FormControlLabel value="Single" control={<Radio />} label="Single"  />
                     <FormControlLabel value="Married" control={<Radio />} label="Married"   />
                   </RadioGroup>
                 </FormControl>
               </Grid>
             </Grid>
            
             </Box>
             
             <Box sx={{ backgroundColor: "#f8f9e9", padding: 2 }}>
             <Grid container spacing={2} alignItems="center">
                 {/* ID Proof Label & Radio Buttons in One Row */}
                 <Grid item xs={2}>
                 <FormLabel sx={{ whiteSpace: "nowrap"}} required>ID Proof </FormLabel>
                   </Grid>
                   <Grid item xs={13} sm={10}>
                     <FormControl component="fieldset" style={{ marginLeft: "22px" }}>
                       <RadioGroup row name="ID_Proof_Type" value={formData.ID_Proof_Type} onChange={handleRadioChange} >
                         <FormControlLabel
                        
                           value="aadhaar"
                           control={<Radio sx={{ color: "gray" }}  />}
                           label="Aadhaar"
                         />
                         <FormControlLabel
                           value="license"
                           control={<Radio sx={{ color: "grey" }} />}
                           label="License"
                         />
                         
                       </RadioGroup>
                     </FormControl>
                   </Grid>


                   {/* Aadhar Number Field */}
                   {formData.ID_Proof_Type === "aadhaar" && (
                     <Grid item xs={12}>
                       <TextField
                         fullWidth
                         required
                         size="small"
                         label="Aadhaar Number"
                         type="text"
                         name="ID_Proof_Number"
                         value={formData.ID_Proof_Number}
                         onChange={handleChange}
                         error={isSubmitted && !formData.ID_Proof_Number}
helperText={isSubmitted && !formData.ID_Proof_Number ? "" : ""}

                    
                          placeholder="Enter Aadhaar Number"
                         onInput={(e) =>
                           (e.target.value = e.target.value.replace(/\D/g, "").slice(0, 12))
                         } 
                         onKeyDown={handleKeyDown} 
                       />
                    
                     </Grid>
                   )}
                 {/* License Number Field */}
                 {formData.ID_Proof_Type === "license" && (
                   <Grid item xs={12}>
                     <TextField
                       fullWidth
                       required
                       size="small"
                       label="License Number"
                       type="text"
                       name="ID_Proof_Number"
                       value={formData.ID_Proof_Number}
                       placeholder="Enter License Number"
                       onChange={handleChange}
                       error={
                        isSubmitted &&
                        (!formData.ID_Proof_Number
                          ? true
                          : !/^[A-Z]{2}\d{13}$/.test(formData.ID_Proof_Number))
                      }
                      helperText={
                        isSubmitted &&
                        (!formData.ID_Proof_Number
                          ? " "
                          : !/^[A-Z]{2}\d{13}$/.test(formData.ID_Proof_Number)
                          ? " "
                          : "")
                      }
                
                      inputProps={{ maxLength: 15 }}
                      
                      onInput={(e) =>
                        (e.target.value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 15))
                      }
                      onKeyDown={handleKeyDown} 
             
                     />
                   </Grid>
                     )}
                   </Grid>
                   </Box>
                       {/* PAN Requirement Selection */}
                       <Box sx={{ backgroundColor: "#f8f9e9", padding: 2 }}>
                 <Grid container spacing={2} alignItems="center">
                  
                   {/* PAN Number Label */}
                   <Grid item xs={2}>
                   <FormLabel sx={{ whiteSpace: "nowrap"}} required>PAN Card</FormLabel>
                   </Grid>


                   {/* PAN Required Radio Buttons */}
                   <Grid item xs={12} sm={10}>
                     <FormControl component="fieldset" style={{ marginRight: "28px" }} >
                       <RadioGroup row name="Pan_Card" value={formData.Pan_Card}
                       onChange={handlePanChange}
                      
                      >
                         <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                         <FormControlLabel value="No" control={<Radio />} label="No" />
                
                       </RadioGroup>
                     </FormControl>
                   </Grid>


                 </Grid>
                 <Box sx={{ backgroundColor: "#f8f9e9", mt:2}}>

                   {/* PAN Number Field (Only if "Yes" is selected) */}
                   {formData.Pan_Card === "Yes" && (
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          required
                          size="small"
                          label="PAN Number"
                          placeholder="Enter PAN Number"
                          name="Pan_Number"
                          value={formData.Pan_Number}
                          onChange={(e) => {
                            const formattedValue = e.target.value
                              .toUpperCase()
                              .replace(/[^A-Z0-9]/g, "")
                              .slice(0, 10);
                            handleChange({
                              target: { name: "Pan_Number", value: formattedValue },
                            });
                          }}
                          error={
                            isSubmitted &&
                            (!formData.Pan_Number
                              ? true
                              : !/^[A-Z]{5}\d{4}[A-Z]{1}$/.test(formData.Pan_Number))
                          }
                          helperText={
                            isSubmitted &&
                            (!formData.Pan_Number
                              ? " "
                              : !/^[A-Z]{5}\d{4}[A-Z]{1}$/.test(formData.Pan_Number)
                              ? " "
                              : "")
                          }
                          inputProps={{ maxLength: 10 }}
                          
                          onInput={(e) =>
                            (e.target.value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 10))
                          }
                          onKeyDown={handleKeyDown} 
                        />
                      </Grid>
                    </Grid>
                  )}

                       </Box>
                       </Box>
                       </div>
                  
                  </Box>
                 
                   <Grid container spacing={2} justifyContent="center" sx={{ mt: 2 }} >
                    <Grid item>

                        {isLoading ? (
                                        <CircularProgress color="success" />
                                    ) : (
                                      <Button type="submit" variant="contained" onClick={handleSubmit}
                                      fullWidth style={{ backgroundColor: "green", color: "white" }}
                                      >
                                          Update Member 
                                      </Button>
                                    )}
                     
                    </Grid>
                    <Grid item>
                    {isPaymentPending && (
                      isPaymentLoading ? (
                        <CircularProgress color="primary" />
                      ) : (
                        <Button
                          type="button"
                          variant="contained"
                          onClick={handleProceedPayment}
                          fullWidth
                          style={{ backgroundColor: "#1E6BB8", color: "white" }}
                        >
                          Proceed Payment
                        </Button>
                      )
                    )}

                        </Grid>
                      <Grid item>
                              <Button variant="contained" fullWidth style={{ backgroundColor: "#E52029", color: "white" }} 
                              onClick={() => {
                                navigate("/landing");
                                window.scrollTo(0, 0);
                              }}
                               >
                                  Cancel
                              </Button>
                              </Grid>
                      </Grid>
                      </Grid>
        )}</Container>


       {/* Snackbar Alert */}
       <Snackbar open={openSnackbar} autoHideDuration={2000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: "top", horizontal: "right" }}  >
               <Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: "100%", fontSize: "16px", fontWeight: "bold" }}>
               Member Updated Successfully!
               </Alert>
       </Snackbar>




        <Snackbar open={snackbarOpen} autoHideDuration={10000} onClose={() => setSnackbarOpen(false)} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
              <Alert onClose={() => setSnackbarOpen(false)} severity="error"sx={{ width: "100%", fontSize: "16px", fontWeight: "bold" }}>{snackbarMessage}</Alert></Snackbar>

          

              {/* Dialog Pop-up */}
              <Dialog open={openDialog} onClose={() => setOpenDialog(false)}
                sx={{ 
                  "& .MuiPaper-root": { 
                    backgroundColor: "#f8f9e9", 
                    borderRadius: "10px" 
                  }
                }}>
              <DialogTitle sx={{ textAlign: "center", fontWeight: "bold" }}>
                Important Notice
              </DialogTitle>

              <DialogContent sx={{ textAlign: "justify", p: 3 }}>

              Please note: The Membership ID card will only be generated if you select <em> 'Yes' </em> and provide your PAN Card number. 
              If you select <em> 'No' </em>, the ID card will <strong> not </strong> be generated.
               
              </DialogContent>

              <DialogActions sx={{ justifyContent: "center" }}>
                <Button
                  onClick={() => setOpenDialog(false)}
                  variant="contained"
                  color="primary"
                >
                  OK
                </Button>
              </DialogActions>
            </Dialog>

          



   </Box>
 );
}